var sideMenuItems = {
    items: [
        {
            icon: "fas fa-user",
            label: "MyAccount",
            group: "Agreements",
            isVisible: "o=>o.read.value",
            description: "",
            href: "/account"
        },
        {
            icon: "fas fa-users",
            label: "Users",
            group: "Users",
            isVisible: "o=>o.read.value",
            description: "",
            href: "/user"
        },
        {
            icon: "fas fa-file-contract",
            label: "Agreements",
            group: "Agreements",
            isVisible: "o=>o.read.value",
            description: "",
            href: "/agreement"
        },
    ]
}

export default sideMenuItems;
